import * as type from './constants';

export const setLoginStep = step => ({
  type: type.SET_LOGIN_STEP,
  step
});

export const setLoginAttemptToken = token => ({
  type: type.SET_LOGIN_ATTEMPT_TOKEN,
  token
});

export const setChallengeToken = token => ({
  type: type.SET_CHALLENGE_TOKEN,
  token
});

export const setLoginValues = (field, value) => ({
  type: type.SET_LOGIN_VALUES,
  field,
  value
});

export const clearLoginFlow = () => ({
  type: type.CLEAR_LOGIN_FLOW
});

export const setInitialEstablishments = data => ({
  type: type.SET_INITIAL_ESTABLISHMENTS,
  data
});

export const setAllEstablishments = data => ({
  type: type.SET_ALL_ESTABLISHMENTS,
  data
});

export const setAppPermissionEstablishments = (data, isAdminUser) => ({
  type: type.SET_APP_PERMISSION_ESTABLISHMENTS,
  data,
  isAdminUser
});

export const setUsersSituation = data => ({
  type: type.SET_USERS_SITUATION,
  data
});

export const setNewEstablishment = data => ({
  type: type.SET_NEW_ESTABLISHMENT,
  data
});

export const setSingleEstablishment = data => ({
  type: type.SET_SINGLE_ESTABLISHMENT,
  data
});

export const setUpdatedEstablishment = data => ({
  type: type.SET_UPDATED_ESTABLISHMENT,
  data
});

export const setUuid = uuid => ({
  type: type.SET_UUID,
  uuid
});

export const setTermsOfUseDate = date => ({
  type: type.SET_TERMS_OF_USE_DATE,
  date
});

export const handleLoading = status => ({
  type: type.HANDLE_LOADING,
  status
});

export const updateToken = token => ({
  type: type.UPDATE_TOKEN,
  token
});

export const handleLogout = () => ({
  type: type.HANDLE_LOGOUT
});

export const setIsTermsOfUseChecked = checked => ({
  type: type.SET_IS_TERMS_OF_USE_CHECKED,
  checked
});